import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'
import EventEmitter from '../../../utils/events'

// import { FILE_STORAGE } from '../../../constants'

// Actions
import { setCarPriceParts } from '../../../actions/price'
import { updatePrices, getPrices } from '../../../actions/orderPrice'
import { getPriceInformations } from '../../../actions/priceModel'
import { deleteDeviationFileFromOrder, setOrder, uploadMultipleFiles, getOrder, getExtentInfo, saveOrder, getOrderFiles, UpdateOrderFileSelection, createFileContainer } from '../../../actions/orders'
import { getCustomer } from '../../../actions/customers'
import { getShop } from '../../../actions/shops'
import { createNote } from '../../../actions/notes'

import { hasAccess, hasPartnerSubscriptionPermission } from '../../../utils/auth'
import { triggerPopup, triggerPopupActionBG } from '../../../actions/backdrop'

// Components
import Price from './Price'
import Estimation from './Estimation'
import Complaint from './Complaint'
import Other from './Other'
import Deviation from './Deviation'
import ManualBody from './ManualBody'
import OtherDamages from './OtherDamages'
import AssessmentForsi from './AssessmentForsi'
import AssessmentDBS from './AssessmentDBS'

import Expand from '../../elements/expand'
import Check from '../../elements/check'
// import Null from '../../elements/null'
import Icon from '../../elements/icon'
import { ElementIcons } from '../../elements/icons'

import './extent.scss'
import { translation } from '../../../utils/helpers'
import Actions from '../../elements/actions'
import CombinedPrice from './CombinedPrice'

const ORDER_BASE = 'base'
const ORDER_ADDON = 'addon'
const ORDER_EVAL = 'eval'
const ORDER_AFTEREVAL = 'aftereval'
const ORDER_INTDEV = 'intdeviation'
const ORDER_EXTDEV = 'extdeviation'
const ORDER_OTHDMG = 'otherdamage'

const EXTENT_NONE = 'none'
const EXTENT_PRICE = 'price'
const EXTENT_EST = 'estimation'
const EXTENT_DEV = 'deviation'
const EXTENT_COMPL = 'complaint'
const EXTENT_OTHER = 'other'
const EXTENT_MANUAL_BODY = 'manual_body'
const EXTENT_OTHER_DAMAGE = 'other_damage'
const EXTENT_COMBINED_PRICE = 'combined_price'
const EXTENT_ASSESSMENT_FORSI = 'assessment_forsi'
const EXTENT_ASSESSMENT_DBS = 'assessment_dbs'

/**
 * Corresponds to enum used in getExtentInfo API.
 */
const EXTENTINFO_TYPES = {
  None: 0,
  ForsiReport: 1,
  // ManualForsi: 2,
  DBSReport: 3,
  // ManualDBS: 4,
  PriceCalculation: 5,
  Complaint: 6,
  Estimation: 7,
  Other: 8
}
/**
 * Component for displaying one or more extents of different types. Specify in props which extents are wanted, such as 'base', 'addon', 'aftereval' etc. (refer to ORDER_* constants above)
 */
class Extent extends Component {

  constructor (props) {
    super(props)
    this.state = {
      order: null,
      extentInfo: null,
      department: 0,
      isLoading: false,
      noOrderPrice: false,
      extentData: [{
        orderPrice: null,
        partTasks: null,
        isLoading: true,
        noOrderPrice: false
      }],
      showAgreementPrice: 0
    }

    this.componentConfig = {
      [EXTENT_NONE]: null,
      [EXTENT_PRICE]: Price,
      [EXTENT_EST]: Estimation,
      [EXTENT_OTHER]: Other,
      [EXTENT_COMPL]: Complaint,
      [EXTENT_DEV]: Deviation,
      [EXTENT_MANUAL_BODY]: ManualBody,
      [EXTENT_OTHER_DAMAGE]: OtherDamages,
      [EXTENT_COMBINED_PRICE]: CombinedPrice,
      [EXTENT_ASSESSMENT_FORSI]: AssessmentForsi,
      [EXTENT_ASSESSMENT_DBS]: AssessmentDBS
    }

    this.saveOrder = this.saveOrder.bind(this)
    this.loadOrder = this.loadOrder.bind(this)
    this.saveOrderPrice = this.saveOrderPrice.bind(this)
    this.getExtentInfo = this.getExtentInfo.bind(this)
    this.loadExtentData = this.loadExtentData.bind(this)
  }

  componentDidMount () {
    this.loadData(this.props)
  }

  componentWillReceiveProps (props, newProps) {
    let prevProps = this.props
    newProps = newProps.order !== undefined ? newProps : props
    let needUpdate = false
    if (newProps.order !== undefined) {
      // Conditions under which (sub)components needs to fetch updated data.
      if (typeof newProps.order === 'number' && newProps.order !== prevProps.order) {
        needUpdate = true
      }

      if (!needUpdate) {
        let orderFields = [
          'Id',
          'Delivery',
          'IsAssessmentOk',
          'IsDraft'
        ]
        for (let key in orderFields) {
          if (newProps.order[orderFields[key]] !== prevProps.order[orderFields[key]]) {
            needUpdate = true
            break
          }
        }
      }
    }

    const setOrderPrice = (propsOrderPrice) => {
      if (propsOrderPrice === undefined) return null
      let extentData = this.state.extentData
      for (let i = 0; i < extentData.length; i++) {
        if (this.compareOrderPriceAssociation(extentData[i].orderPrice, propsOrderPrice)) {
          extentData[i].orderPrice = propsOrderPrice
          this.setState({ extentData: extentData })
        }
      }
    }

    if (needUpdate) {
      // Delay setting orderPrice until after new data is loaded.
      this.loadData(newProps).then(() => {
        setOrderPrice(newProps.price)
      })
    } else {
      setOrderPrice(newProps.price)
    }
  }

  /**
   * Loads order (or gets it from prop object directly), and loads OrderPrices where relevant.
   * @param {object} newProps
   */
  loadData (newProps) {
    // console.log('Extent -> loadData', newProps)
    // Init extentData from extentArgs in props
    let extentArgs = [...newProps.extents]
    let extentData = []
    extentArgs.map((v, k) => {
      extentData.push({ orderPrice: null, partTasks: null, isLoading: true })
    })
    this.setState({
      extentData: extentData,
      showAgreementPrice: window.localStorage.getItem('showAgreementPrice') === '1'
    })
    return new Promise((resolve) => {
      // Store or get order data
      return this.loadOrder(false, newProps.order).then(() => {
        // Get extent data for each extent
        extentArgs.map((v, k) => {
          this.loadExtentData(k).then(() => {
            // console.log('Extent data loaded for ' + extentArgs[k].type)
          })
          this.loadPartTasks(k).catch(e => {})
        })
        resolve()
      })
    })
  }

  loadOrder (refresh = false, overrideOrder) {
    let order = overrideOrder !== undefined ? overrideOrder : this.props.order
    // console.log('Extent -> LoadOrder(), refresh', refresh, 'this.state.order', this.state.order)
    if (typeof order === 'number' || (refresh === true && this.state.order !== null)) {
      // order was given as ID or want to refresh. Load order.
      let orderId = order
      if (refresh && this.state.order !== null) {
        orderId = this.state.order.Id
      }
      this.getExtentInfo(orderId)
      return this.props.getOrder(orderId).then((res) => {
        let order = res.data
        this.setState({
          order: order
        })
      })
    } else if (typeof order === 'object' && typeof order.Id === 'number') {
      // order was given as object. Use object.
      this.getExtentInfo(order.Id)
      return new Promise((resolve) => {
        this.setState({order: order}, () => {
          resolve()
        })
      })
    } else {
      console.error('Order ID or object not provided to Extent!')
    }
    return Promise.reject()
  }

  getExtentInfo (orderId) {
    this.props.getExtentInfo(orderId).then(res => {
      // console.table(res.data)
      this.setState({
        extentInfo: res.data
      })
    })
  }

  saveOrder (order) {
    return new Promise((resolve, reject) => {
      this.props.saveOrder(order).then((res) => {
        this.setState({
          order: res.data
        }, () => {
          EventEmitter.emit('Extent_Updated')
          resolve()
        })
      }, (err) => {
        console.log('Error saving order!', err.response)
        EventEmitter.emit('Extent_Updated')
        reject()
      })
    })
  }

  saveOrderPrice (orderPrice) {
    return new Promise((resolve, reject) => {
      let index = this.state.extentData.findIndex(extent => { return extent.orderPrice && extent.orderPrice.OrderPriceId === orderPrice.OrderPriceId })
      this.props.updatePrices(orderPrice).then((res) => {
        if (index >= 0) {
          // orderPrice present in state. Update.
          let extentData = [...this.state.extentData]
          extentData[index].orderPrice = res.data
          this.setState({
            extentData: extentData
          }, () => {
            EventEmitter.emit('Extent_Updated')
            resolve()
          })
        } else resolve()
      }, (err) => {
        console.log('Error saving OrderPrice!', err.response)
        EventEmitter.emit('Extent_Updated')
        reject()
      })
    })
  }

  loadPartTasks (extentIndex) {
    let extentArgs = this.props.extents[extentIndex]
    let orderId = typeof this.state.order === 'object' ? this.state.order.Id : this.state.order
    let orderType = this.state.order.OrderType
    let customerId = this.state.order.CustomerId
    let brandName = this.state.order.BrandName.Name
    let isBodyShop = this.props.department > 0

    let isEstimation = false
    let deviation = null
    let isAddon = false
    let otherDamage = false

    switch (extentArgs.type) {
      case ORDER_BASE:
        break
      case ORDER_ADDON:
        isAddon = true
        break
      case ORDER_EVAL:
        isEstimation = true
        break
      case ORDER_AFTEREVAL:
        isEstimation = true
        break
      case ORDER_INTDEV:
        deviation = 1
        break
      case ORDER_EXTDEV:
        deviation = 2
        break
      case ORDER_OTHDMG:
        otherDamage = true
        break
    }
    return new Promise((resolve, reject) => {
      if (this.isOrderPriceExtent(extentArgs)) {
        this.props.getPriceInformations(orderType, brandName, customerId, deviation, isEstimation, isAddon, orderId, isBodyShop, otherDamage).then((res) => {
          // Store for extent
          let extentData = this.state.extentData
          extentData[extentIndex].partTasks = res.data
          this.setState({
            extentData: extentData
          }, () => {
            if (typeof resolve === 'function') { resolve() }
          })
        }, (err) => {
          console.log('Error getting parttask data', err.response)
          if (typeof reject === 'function') {
            reject()
          }
        })
      } else {
        if (typeof resolve === 'function') { resolve() }
      }
    })
  }

  /**
   * Loads extent data, such as an OrderPrice for extent at given index.
   * @param {number} extentIndex
   */
  loadExtentData (extentIndex) {
    let extentArgs = this.props.extents[extentIndex]
    return new Promise((resolve, reject) => {
      if (this.isOrderPriceExtent(extentArgs)) {
        let addon = false
        let evaluation = false
        let afterevaluation = false
        let deviation = 0
        let otherDamage = false
        let getOnly = extentArgs.getOnly !== undefined ? extentArgs.getOnly : !extentArgs.editable
        let getEditing = extentArgs.editable
        let useSelectedEval = extentArgs.useSelectedEvaluation
        let department = this.props.department

        // Set parameters for OrderPrice/Get
        switch (extentArgs.type) {
          case ORDER_BASE:
            break
          case ORDER_ADDON:
            addon = true
            break
          case ORDER_EVAL:
            evaluation = true
            break
          case ORDER_AFTEREVAL:
            afterevaluation = true
            break
          case ORDER_INTDEV:
            deviation = 1
            break
          case ORDER_EXTDEV:
            deviation = 2
            break
          case ORDER_OTHDMG:
            otherDamage = true
            break
        }

        let extentData = this.state.extentData

        if (this.props.prices === null || !this.compareOrderPriceAssociation(extentData[extentIndex].orderPrice, this.props.price)) {
          extentData[extentIndex].isLoading = true
          this.setState({extentData: extentData}, () => {
            // console.log('Load orderprice (' + extentArgs.type + ')...', this.state.order.Id)
            this.props.getPrices(this.state.order.Id, addon, evaluation, afterevaluation, deviation, otherDamage, getEditing, useSelectedEval, department, getOnly).then(res => {
              extentData = this.state.extentData
              extentData[extentIndex].orderPrice = res.data
              extentData[extentIndex].isLoading = false
              extentData[extentIndex].noOrderPrice = false
              this.setState({extentData: extentData}, () => {
                EventEmitter.emit('Extent_Updated')
                if (typeof resolve === 'function') {
                  resolve()
                }
              })
            }, () => {
              if (!this.props.editable) {
                extentData = this.state.extentData
                extentData[extentIndex].isLoading = false
                extentData[extentIndex].noOrderPrice = true
                this.setState({extentData: extentData}, () => {
                  EventEmitter.emit('Extent_Updated')
                  if (typeof reject === 'function') {
                    reject()
                  }
                })
              } else {
                EventEmitter.emit('Extent_Updated')
                if (typeof reject === 'function') {
                  reject()
                }
              }
            })
          })
        }
      }
      if (typeof resolve === 'function') {
        resolve()
      }
    })
  }

  /**
   * Compares 2 orderPrices to check if they represent the same 'type' of extent (since OrderPriceId can change but still represent the same shown extent)
   * Useful when checking OrderPrice updates in reducer, when multiple OrderPrices must be supported (showing Base together with Addon fx).
   * @param {object} orderPriceA
   * @param {object} orderPriceB
   */
  compareOrderPriceAssociation (orderPriceA, orderPriceB) {
    if ((orderPriceA === null) !== (orderPriceB === null)) return false
    if (orderPriceA.OrderId !== orderPriceB.OrderId) return false
    if (orderPriceA.Department !== orderPriceB.Department) return false
    if (orderPriceA.IsAddonPrice !== orderPriceB.IsAddonPrice) return false
    if (orderPriceA.IsEvaluation !== orderPriceB.IsEvaluation) return false
    if (orderPriceA.IsAfterEvaluation !== orderPriceB.IsAfterEvaluation) return false
    if (orderPriceA.IsComplaint !== orderPriceB.IsComplaint) return false
    if (orderPriceA.IsInternalDeviation !== orderPriceB.IsInternalDeviation) return false
    if (orderPriceA.IsExternalDeviation !== orderPriceB.IsExternalDeviation) return false
    if (orderPriceA.UseEstimation !== orderPriceB.UseEstimation) return false
    return true
  }

  isOrderPriceExtent (extentType) {
    if (this.state.order === null) {
      return null
    }

    let orderTypes = [1, 2, 3, 5, 6]
    let orderExtentTypes = [ORDER_ADDON, ORDER_EVAL, ORDER_AFTEREVAL, ORDER_INTDEV, ORDER_EXTDEV, ORDER_OTHDMG]

    if (orderTypes.includes(this.state.order.OrderType) || orderExtentTypes.includes(extentType)) {
      return true
    }
    return false
  }

  /**
   * Returns type of component for extent at given index.
   * @param {number} extentIndex
   */
  getExtentComponentType (extentIndex) {
    let orderType = this.state.order.OrderType
    let selectedEvaluationType = this.state.order.SelectedEvaluationType
    let hasOrderPrice = this.state.extentData[extentIndex].orderPrice !== null
    let useEstimation = hasOrderPrice && this.state.extentData[extentIndex].orderPrice.UseEstimation
    let hasReport = this.state.order.Report !== null && (this.props.department === 0 ? this.state.order.Report.Paint !== null : this.state.order.Report.Body !== null)

    let extentArgs = this.props.extents[extentIndex]
    let extentType = null

    let extentInfoType = EXTENTINFO_TYPES.None
    if (extentArgs.type === ORDER_BASE || extentArgs.type === ORDER_ADDON) {
      let baseOrAddon = extentArgs.type === ORDER_BASE ? 'Base' : 'Addon'
      let paintOrBody = this.props.department === 0 ? 'Paint' : 'Body'

      if (this.state.extentInfo) {
        extentInfoType = this.state.extentInfo[paintOrBody + baseOrAddon]
      }
    }

    let defaultBaseExtentPerOrder = {
      1: EXTENT_EST,
      2: EXTENT_PRICE,
      3: EXTENT_PRICE,
      4: EXTENT_OTHER,
      5: EXTENT_COMPL,
      6: EXTENT_PRICE
    }

    extentType = defaultBaseExtentPerOrder[orderType]

    // console.log('0', extentArgs, extentArgs.type, this.props)

    switch (extentArgs.type) {
      case ORDER_BASE:
        break
      case ORDER_ADDON:
        extentType = EXTENT_PRICE
        break
      case ORDER_EVAL:
      case ORDER_AFTEREVAL:
        extentType = EXTENT_EST
        break
      case ORDER_INTDEV:
      case ORDER_EXTDEV:
        extentType = EXTENT_DEV
        break
      case ORDER_OTHDMG:
        extentType = EXTENT_OTHER_DAMAGE
        break
    }
    // In case of displaying paint base extent for shop with no estimation or price lists (ex. bodyshop with no paint partner)
    if (this.props.auth.departmentType === 1 && this.props.department === 0 && extentArgs.type === ORDER_BASE && extentType === EXTENT_PRICE && !useEstimation && extentInfoType !== EXTENTINFO_TYPES.PriceCalculation) {
      extentType = EXTENT_OTHER
    }

    if (useEstimation && extentArgs.type !== ORDER_OTHDMG) {
      extentType = EXTENT_EST
    }

    // If Forsi and DBS report      //  extentInfoType !== EXTENTINFO_TYPES.PriceCalculation
    if (extentArgs.type === ORDER_BASE || extentArgs.type === ORDER_EVAL) {
      switch (extentInfoType) {
        case EXTENTINFO_TYPES.ForsiReport:
          if (hasReport) {
            extentType = EXTENT_ASSESSMENT_FORSI
          } else if (this.props.department !== 0) {
            extentType = EXTENT_MANUAL_BODY
          }
          break
        case EXTENTINFO_TYPES.DBSReport:
          if (hasReport) {
            extentType = EXTENT_ASSESSMENT_DBS
          } else if (this.props.department !== 0) {
            extentType = EXTENT_MANUAL_BODY
          }
          break
      }
    }

    if (extentArgs.type === ORDER_BASE && extentArgs.useSelectedEvaluation === true) {
      if (selectedEvaluationType === 4) {
        extentType = EXTENT_EST
      }
    }

    if (extentArgs.combined && this.props.department === 1 && extentArgs.type === ORDER_BASE) {
      extentType = EXTENT_COMBINED_PRICE
    }

    let result = this.componentConfig[extentType]
    if (result === undefined) {
      console.error('Could not get component type for: ' + extentType)
    }
    return this.componentConfig[extentType]
  }

  /**
   * Adjusts the order objects ShowPrices property according to department and partner permission
   * @param {Number} extentIndex
   * @param {Object} order
   */
  adjustShowPrices (extentIndex, order) {
    if (order !== null) {
      let extentArgs = this.props.extents[extentIndex]
      if (this.isOrderPriceExtent(extentArgs.Type) && this.state.extentData[extentIndex].orderPrice !== null) {
        // let orderPrice = this.state.extentData[extentIndex].orderPrice
        if (this.props.auth.hasPartner && this.props.auth.departmentType === 1 && extentArgs.type === ORDER_BASE && this.props.department === 0 && hasPartnerSubscriptionPermission(this.props.auth, 20)) {
          // ShowPrices overriden to true because paint partner is allowed to view prices
          const dirtyOrder = { ...order }
          dirtyOrder.ShowPrices = true
          return dirtyOrder
        }
      }
    }
    return order
  }

  renderAgreementPriceCheck (extentArgs) {
    const onChange = (e) => {
      // e.preventDefault()
      if (e !== undefined) {
        if (e.target.name === 'showAgreementPrice') {
          let show = window.localStorage.getItem('showAgreementPrice') === '1'
          window.localStorage.setItem('showAgreementPrice', show ? 0 : 1)
          this.setState({
            showAgreementPrice: !show
          })
        }
      }
    }

    // Only main paint extent to render checkbox
    if (this.props.department !== 0 || extentArgs.type !== 'base') return null
    // Only wp
    if (!hasAccess([6], this.props.auth.user.UserType) || this.props.order.IsDummy) return null

    return (
      <Check
        name='showAgreementPrice'
        id='sshowAgreementPrice'
        checked={this.state.showAgreementPrice}
        onChange={onChange.bind(this)}
        labelText={translation('12318')}
      />
    )
  }

  renderExtent (extentIndex) {
    let error = null
    if (this.props.extents.length - 1 < extentIndex) {
      error = 'Extent index ' + extentIndex + 'out of range!'
    }
    let extentArgs = this.props.extents[extentIndex]
    if (extentArgs.type === undefined || extentArgs.type === null || extentArgs.type === '') {
      error = 'No extent type specified for extent[' + extentIndex + ']'
    }

    const renderSpinner = () => {
      return (
        <div key={'extent_' + extentIndex} className='extent-container'>
          <div className='spinner'>
            <div className='fa fa-spinner fa-spin fa-3x fa-fw' />
          </div>
        </div>
      )
    }

    if (this.isOrderPriceExtent(extentArgs.type)) {
      if (this.state.extentData[extentIndex].orderPrice === null && !this.state.extentData[extentIndex].noOrderPrice) {
        return renderSpinner()
      }
    }
    if (error !== null) {
      console.error(error)
      return
    }
    let refName = 'extent_' + extentIndex
    let order = this.adjustShowPrices(extentIndex, this.state.order)

    let extentProps = {
      order: order,
      extentInfo: this.state.extentInfo,
      editable: extentArgs.combined ? false : extentArgs.editable,
      showEditLink: extentArgs.showEditLink,
      overrideInnerTitle: extentArgs.overrideInnerTitle !== undefined ? extentArgs.overrideInnerTitle : null,
      viewMode: extentArgs.viewMode !== undefined ? extentArgs.viewMode : null,
      showOnlyWork: extentArgs.showOnlyWork === true,
      renderInside: extentArgs.renderInside !== undefined ? extentArgs.renderInside : null,
      saveOrder: this.saveOrder,
      saveOrderPrice: this.saveOrderPrice,
      loadOrder: this.loadOrder,
      isCustomer: hasAccess([4], this.props.auth.user.UserType),
      isWp: hasAccess([6], this.props.auth.user.UserType),
      showAgreementPrice: this.state.showAgreementPrice === true,
      isAgreement: this.props.order.IsAgreement,
      department: this.props.department,
      partTasks: this.state.extentData[extentIndex].partTasks,
      orderPrice: this.state.extentData[extentIndex].orderPrice,
      useSelectedEvaluation: extentArgs.useSelectedEvaluation,
      goBack: this.props.goBack,
      router: this.props.router,
      onRef: (ref) => {
        this[refName] = ref
        this.forceUpdate()
      }
    }

    // console.log('render extent -> extentProps', extentProps)

    let extentComponentType = this.getExtentComponentType(extentIndex)
    if (extentComponentType === null) return null
    let extentComponent = React.createElement(extentComponentType, extentProps)

    let extentTitle = 'Implement getTitle function for this component!'
    let extentTitleAria = 'Implement getTitleAria function for this component!'
    // let extentIcon = null
    let extentEditUrl = null

    let ref = this[refName]
    if (ref !== undefined && ref !== null) {
      // console.log('ref Extent [' + extentIndex + ']', ref)
      if (ref.getTitle !== undefined) extentTitle = ref.getTitle()
      if (ref.getTitleAria !== undefined) extentTitleAria = ref.getTitleAria()
      // if (ref.getIcon !== undefined) extentIcon = ref.getIcon()
      if (ref.getEditUrl !== undefined) extentEditUrl = ref.getEditUrl()
    }

    if (extentArgs.overrideTitle !== undefined) {
      extentTitle = extentArgs.overrideTitle
    }

    const renderExtentHeading = (content) => {
      if (extentArgs.editable || extentArgs.noTitle) return content
      if (typeof extentTitle === 'function') {
        return (
          <Expand title={translation('889')/* extentTitle */} defaultOpen>
            <Actions>
              {extentTitle()}
            </Actions>
            {content}
          </Expand>
        )
      }

      if (extentArgs.showEditLink && extentEditUrl !== null) {
        return (
          <Expand title={translation('889')/* extentTitle */} defaultOpen>
            <Actions>
              <a href={extentEditUrl} key='1'>
                <Icon icon={ElementIcons.Edit} size='t' ariaText={extentTitleAria} ariaPos='top' />
              </a>
            </Actions>
            {content}
          </Expand>
        )
      }
      return (
        <Expand title={translation('889')/* extentTitle */} defaultOpen>
          {content}
        </Expand>
      )
    }
    let contentCss = 'extent-content'
    if (extentArgs.editable === true) {
      contentCss += ' editable'
    }
    // let departmentDebug = this.props.department === 0 ? 'paint' : 'body'
    // <div>(Debug info) Extent container for {extentArgs.type}/{departmentDebug} ({extentComponentType.displayName})</div>
    return (
      <div key={'extent_' + extentIndex} className='extent-container'>
        {renderExtentHeading(
          <div className={contentCss}>
            {this.renderAgreementPriceCheck(extentArgs)}
            {extentComponent}
          </div>
        )}
      </div>
    )
  }

  render () {
    // console.log('Extent -> Render ->this.props', this.props)
    if (this.state.order === null) {
      return (
        <div className='extents'>
          <div className='extent-container'>
            <div className='spinner'>
              <div className='fa fa-spinner fa-spin fa-3x fa-fw' />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className='extents'>
        {this.props.extents.map((v, k) => this.renderExtent(k))}
      </div>
    )
  }

}

Extent.propTypes = {
  order: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.object]),
  department: React.PropTypes.number.isRequired,
  extents: React.PropTypes.arrayOf(React.PropTypes.shape({
    type: React.PropTypes.string.isRequired,
    editable: React.PropTypes.bool.isRequired,
    showEditLink: React.PropTypes.bool,
    overrideTitle: React.PropTypes.string,
    overrideInnerTitle: React.PropTypes.string,
    viewMode: React.PropTypes.string,            // undefined, 'hover', ... add as needed
    showOnlyWork: React.PropTypes.bool,
    useSelectedEvaluation: React.PropTypes.bool
  })).isRequired,
  getPrices: React.PropTypes.func.isRequired,
  updatePrices: React.PropTypes.func.isRequired
}

Extent.contextTypes = {
  router: React.PropTypes.object.isRequired
  // router: PropTypes.object
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    complaintTypes: state.common.enums.complaintTypes,
    price: state.price.price
  }
}

export default connect(mapStateToProps, {
  getPrices,
  updatePrices,
  deleteDeviationFileFromOrder,
  setOrder,
  getOrder,
  getExtentInfo,
  saveOrder,
  uploadMultipleFiles,
  createNote,
  triggerPopup,
  triggerPopupActionBG,
  getCustomer,
  getShop,
  getOrderFiles,
  UpdateOrderFileSelection,
  setCarPriceParts,
  createFileContainer,
  getPriceInformations
}, null, { withRef: true })(Extent)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/index.js